import type { IProductMetafields } from "@repo/shopify/src/queries/product-gql";
import type { MediaImage, Metaobject, Product, SelectedOption } from "@shopify/hydrogen-react/storefront-api-types";
import type { Maybe } from "graphql/jsutils/Maybe";

export interface IProductLaunch {
  content: string;
  time: string | string[];
  image: { width: number; height: number; url: string };
  title: string;
  isDetail?: boolean;
}

export type TProduct = Product & IProductMetafields;
export const getProductLaunch = (
  product: TProduct | null,
): {
  content: string;
  time: string;
  image: { width: number; height: number; url: string };
  title: string;
  processed?: boolean; // processed: required 필드가 아니므로 값은 true, false, undefined가 될 수 있음
} => {
  function isJsonString(str: string) {
    try {
      JSON.parse(str);
    } catch (error) {
      return false;
    }
    return true;
  }

  const result: ReturnType<typeof getProductLaunch> = {
    title: "",
    content: "",
    image: { width: 0, height: 0, url: "" },
    time: "",
    processed: undefined,
  };

  if (!product?.launch) return result;

  (product.launch.reference as Maybe<Metaobject>)?.fields.forEach((item) => {
    const fieldValue = String(item.value);

    if (Boolean(item.key) && Boolean(item.value) && item.key.includes("description")) result.content = fieldValue;
    // drop_date 필드와 processed 필드의 구분이 안돼서 item.key를 보고 구분
    // JSON.parse의 return type이 any이므로 string으로 타입 캐스팅
    else if (isJsonString(fieldValue) && item.key === "drop_date") result.time = JSON.parse(fieldValue) as string;
    else if (item.key === "processed") result.processed = true;
    else if (fieldValue.includes("gid")) {
      if ((item.reference as MediaImage).image) {
        result.image = {
          width: (item.reference as MediaImage).image?.width || 0,
          height: (item.reference as MediaImage).image?.height || 0,
          url: (item.reference as MediaImage).image?.url || "",
        };
      }
    } else result.title = fieldValue;
  });

  return result;
};

export const getAvailableSize = (product: TProduct) => {
  return product.variants
    ? product.variants.edges
        .filter(({ node }) => node.availableForSale)
        .map(({ node }) => ({
          value: node.id,
          name:
            node.selectedOptions.find((option: SelectedOption) => ["Size", "사이즈"].includes(option.name))?.value ??
            "",
          quantity: node.quantityAvailable,
        }))
    : [];
};
